var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnableCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5102,
    cy: 24,
    rx: 23.5102,
    ry: 24,
    fill: "#175FFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6626 29.9138L14.9792 24.2304L16.5376 22.6721L20.6626 26.7971L29.4397 18.02L30.998 19.5784L20.6626 29.9138Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableCheck);
export default __webpack_public_path__ + "static/media/enable_check.27bb46cd18e2c7a686b1aa24151fcb62.svg";
export { ForwardRef as ReactComponent };